export class AuthConfig {
    login: string;
    refreshToken?: string;
    refresh: string;
}
